import { withInstall } from '@lit-element/utils'
import Teleport from './src/teleport.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtTeleport: SFCWithInstall<typeof Teleport> = withInstall(Teleport)

export default LtTeleport

export * from './src/teleport'
